module.exports = __webpack_public_path__ + "static/media/electrical.ab7726c5.svg";